import React, { useEffect, useState } from 'react';
import { stalledMedia, playStalledMedia } from '../../utils/mediaPlayback';

// Shown only when the browser has left remote audio or video paused (seen on iOS Safari).
// One tap starts everything, because the tap is the user gesture the browser requires.
// On browsers that autoplay normally it never appears.
export default function TapToStart() {
  const [needsTap, setNeedsTap] = useState(false);

  useEffect(() => {
    const check = () => setNeedsTap(stalledMedia().length > 0);
    check();
    const timer = window.setInterval(check, 1000);
    return () => window.clearInterval(timer);
  }, []);

  // Any tap anywhere is a gesture too: use the first one to start playback quietly.
  useEffect(() => {
    const onGesture = () => {
      playStalledMedia();
    };
    document.addEventListener('touchend', onGesture, { passive: true });
    document.addEventListener('click', onGesture);
    return () => {
      document.removeEventListener('touchend', onGesture);
      document.removeEventListener('click', onGesture);
    };
  }, []);

  if (!needsTap) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => playStalledMedia().then(() => setNeedsTap(stalledMedia().length > 0))}
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 96,
        zIndex: 9000,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <span
        style={{
          pointerEvents: 'auto',
          background: '#f22f46',
          color: '#fff',
          font: '600 16px sans-serif',
          padding: '12px 20px',
          borderRadius: 24,
          boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
        }}
      >
        Tap to start audio and video
      </span>
    </div>
  );
}
